import styled, { keyframes } from 'styled-components';

const successFlash = keyframes`
  0% { background-color: rgba(22, 163, 74, 0.15); }
  100% { background-color: transparent; }
`;

export const InlineEditWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: ${({ theme }) => theme.spacing[1]};
  min-height: 2rem;

  &:hover > button {
    opacity: 1;
  }
`;

export const DisplayValue = styled.span<{ $muted?: boolean; $flash?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme, $muted }) => ($muted ? theme.colors.textMuted : theme.colors.textPrimary)};
  font-style: ${({ $muted }) => ($muted ? 'italic' : 'normal')};
  cursor: pointer;
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[2]}`};
  border-radius: ${({ theme }) => theme.radii.sm};
  transition: background-color ${({ theme }) => theme.transitions.base};
  animation: ${({ $flash }) => ($flash ? successFlash : 'none')} 1.5s ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray100};
  }
`;

export const EditPencilButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.textMuted};
  cursor: pointer;
  opacity: 0;
  transition: opacity ${({ theme }) => theme.transitions.fast};
  border-radius: ${({ theme }) => theme.radii.sm};
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
    background-color: ${({ theme }) => theme.colors.gray100};
  }

  &:focus-visible {
    opacity: 1;
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (hover: none) {
    opacity: 1;
  }
`;

export const SuccessIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.success};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-left: ${({ theme }) => theme.spacing[1]};
`;

export const InlineError = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.danger};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const SavingSpinner = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing[2]};
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  height: 1rem;
  border: 2px solid ${({ theme }) => theme.colors.gray300};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radii.full};
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    to {
      transform: translateY(-50%) rotate(360deg);
    }
  }
`;

export const EditContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CtrlEnterHint = styled.small`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.7rem;
`;

export const ColorInput = styled.input.attrs({ type: 'color' })`
  width: 3rem;
  height: 2rem;
  padding: 0.125rem;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.md};
  cursor: pointer;
`;

export const ColorPresetsRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
  margin-top: ${({ theme }) => theme.spacing[1]};
  flex-wrap: wrap;
`;

export const ColorPresetButton = styled.button<{ $color: string; $selected?: boolean }>`
  width: 1.25rem;
  height: 1.25rem;
  border-radius: ${({ theme }) => theme.radii.sm};
  background-color: ${({ $color }) => $color};
  border: ${({ $selected, theme }) =>
    $selected ? `2px solid ${theme.colors.primary}` : `1px solid ${theme.colors.gray200}`};
  cursor: pointer;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;
